import { render } from "./B2bTableMenuCommercialRelation.vue?vue&type=template&id=a32d37ce&scoped=true&lang=pug"
import script from "./B2bTableMenuCommercialRelation.vue?vue&type=script&lang=js"
export * from "./B2bTableMenuCommercialRelation.vue?vue&type=script&lang=js"

import "./B2bTableMenuCommercialRelation.vue?vue&type=style&index=0&id=a32d37ce&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a32d37ce"]])

export default __exports__